import * as Header from '../components/header';
import { Browser } from '../utils/browsercheck';
import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function deleteEmptyPTags() {
    // Lösche leere p Tags mit Leerzeichen
    for (const p of document.querySelectorAll('#main p')) {
        if (p.innerHTML.replace(/\s| |&nbsp;/g, '') === '') {
            p.remove();
        }
    }
}

/**
 * @param {string} not :not-Selector für Elemente, die kein Icon bekommen sollen
 */
function addExternalLinkClass(not = '') {
    const hostReg = new RegExp(location.hostname, 'i');

    for (const a of document.querySelectorAll(`#main a[href^="http://"]${not}, #main a[href^="https://"]${not}`)) {
        if (!hostReg.test(a.href) && !a.parentElement.classList.contains('image_container')) {
            a.classList.add('external-link');
        }
    }
}

function setCustomProperties() {
    const footer = document.getElementById('footer');

    document.body.style.setProperty('--header-height', `${Header.getHeight(true)}px`);
    document.body.style.setProperty('--scrollbar-width', `${Browser.scrollbarWidth}px`);
    document.body.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
}

function setTouchDeviceClass() {
    if (Browser.isTouchDevice) {
        document.documentElement.classList.add('touch');
    }
}

function fullHeight() {
    for (const img of document.querySelectorAll('.full-height img')) {
        img.style.height = `calc(100vh - ${Header.getHeight()}px)`;
    }
}

function scrollToAnchor() {
    for (const a of document.querySelectorAll('a[href*="#"]')) {
        a.addEventListener('click', function (e) {
            ScrollUtil.scrollToAnchor(e, this);
        });
    }
}

/**
 * Seite einblenden wenn sie fertig geladen ist
 */
function fadeInSite() {
    const loader = document.getElementById('page-loader');

    if (loader) {
        loader.classList.add('hide');
    }

    setTimeout(() => document.documentElement.classList.replace('loading', 'loaded'), 400);
}

/**
 * Das behebt die Warnung vom Browser für "nicht-passive" Touch-Events.
 *
 * Das bedeutet, das `e.preventDefault()` nicht mehr funktioniert in
 * $(element).on('touchstart', function(e) { ... });
 *
 * Wenn ihr die Funktion braucht, müsst ihr das hier wieder rausnehmen oder
 * die JS-Variante addEventListener() verwenden.
 */
function setJqueryTouchEventsAsPassive() {
    if (typeof jQuery === 'undefined') {
        return;
    }

    jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener('touchstart', handle, { passive: true });
        },
    };

    jQuery.event.special.touchmove = {
        setup: function (_, ns, handle) {
            this.addEventListener('touchmove', handle, { passive: true });
        },
    };
}

onDomReady(() => {
    setJqueryTouchEventsAsPassive();
    deleteEmptyPTags();
    addExternalLinkClass();
    setCustomProperties();
    setTouchDeviceClass();
    fullHeight();
    scrollToAnchor();
});

window.addEventListener('load', () => {
    fadeInSite();
    setCustomProperties();

    ScrollUtil.scrollToAnchor(null, window.location);
});

window.addEventListener('resize', () => {
    fullHeight();
    setCustomProperties();
});
